import ctl from '@netlify/classnames-template-literals';

export const companyDetailsContainer = ctl(`
    border-[1px]
    border-azureish-white
    shadow-cetacean-blue
    rounded-md  
    mt-3
  `);

export const companyDetailsContainerTitle = ctl(`
    border-b-[1px] 
    bg-ghost-white 
    border-azureish-white 
    font-[600]
    p-2
    flex
    justify-between
   `);

export const form = ctl(`
p-4 
bg-white
grid 
grid-cols-3 
gap-4
`);

export const button = ctl(`
 text-slate-200
 px-4
 py-2
 mt-4
 rounded-sm
 bg-green-ncs
 text-anti-flash-white
`);

export const deleteButton = 'text - slate - 200 px - 4';
